// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorAvailableProducts = (client) => ({
    /**
     * `GET /vendor/available-products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAvailableProductsList
     * @source apps/backend/src/api/vendor/available-products/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/available-products", { method: "GET", query, headers }),
});
//# sourceMappingURL=available-products.js.map